module.exports = __webpack_public_path__ + "mk.svg?07759242b1fa6fc3047530618e5154ed";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/mk.svg
// module id = 877
// module chunks = 27